/**
 * Local-preview sample data for the FM dashboard pages (F1–F9). Lets the wired FXP routes render
 * in the local shell before the live GRM/RAvail fetches are enabled (blocked: `fm-dse-wire`).
 * Replace these with service calls when the base URLs + auth are wired — the page components read
 * from here via a single import, so swapping to live data is localized.
 */
import { getDays, layoutRows } from './FMTeamCalendar/fmForecastLayout';
import { FMForecastRow } from './FMForecastView/FMForecastView';
import {
  AddEventMasterData,
  EventTypeOption,
  PendingCalendarItem,
} from '../../contracts/FMPendingContracts';
import { ManagerSuggestion } from '../../contracts/FMDashboardContracts';
import { ExportResource } from './shared/exportForecast';

export const fmSampleMonth = new Date(2026, 6, 1); // JUL 2026
export const fmSampleDays = getDays(fmSampleMonth, 31);

export const fmSampleForecastRows: FMForecastRow[] = layoutRows(
  [
    {
      rowId: 'jdoe',
      name: 'Jane Doe (jdoe)',
      utility1: '80%',
      utility2: '75%',
      profileCompletionPercentage: 100,
      skillAssessmentPercentage: 100,
      lastSkillsUpdated: '2026-05-01',
      contractHours: 1800,
      weekends: [0, 6],
      publicHolidays: [4],
      events: [
        { startDateIndex: 2, duration: 4, feature: 'Vacation', colorName: '#0b6a0b', eventtextcolor: '#fff' },
        { startDateIndex: 10, duration: 3, feature: 'Training', colorName: '#8764b8', eventtextcolor: '#fff' },
      ],
    },
    {
      rowId: 'asmith',
      name: 'Al Smith (asmith)',
      utility1: '62%',
      utility2: '70%',
      profileCompletionPercentage: 60,
      skillAssessmentPercentage: 40,
      endorsedStatus: 2,
      contractHours: 1600,
      weekends: [0, 6],
      events: [{ startDateIndex: 14, duration: 6, feature: 'Delivery', colorName: '#0078d4', eventtextcolor: '#fff' }],
    },
    {
      rowId: 'bwayne',
      name: 'Bruce Wayne (bwayne)',
      profileCompletionPercentage: 20,
      skillAssessmentPercentage: 20,
      contractHours: 2000,
      weekends: [0, 6],
      events: [{ startDateIndex: 5, duration: 10, feature: 'Reactive', colorName: '#d13438', eventtextcolor: '#fff' }],
    },
  ],
  31
);

export const fmSampleEventTypes: EventTypeOption[] = [
  { EventTypeId: 1, EventTypeName: 'Vacation', EventColor: '#0b6a0b' },
  { EventTypeId: 2, EventTypeName: 'Training', EventColor: '#8764b8', IsCommentRequired: true },
  { EventTypeId: 3, EventTypeName: 'Delivery', EventColor: '#0078d4', IsSpecialtyRequired: true },
  { EventTypeId: 4, EventTypeName: 'Meeting', EventColor: '#c19c00', IsBusy: false },
  { EventTypeId: 5, EventTypeName: 'Reactive', EventColor: '#d13438' },
];

export const fmSampleExportResources: ExportResource[] = [
  {
    FullName: 'Jane Doe',
    CalendarItems: [
      { Id: 'REQ-1', Name: 'Delivery', TimeZone: 'PST', StartDate: '2026-07-14', EndDate: '2026-07-18', Status: 'Confirmed', AssignmentType: 'Contiguous', TotalDuration: 40, AdditionalProperties: { IsSystemGenerated: 'true', CustomerName: 'Contoso', DeliveryLocation: 'US', DemandSourceId: 'DS-9', MIP: 'Azure', RequestorAlias: 'boss', Comments: 'note', TravelNotes: 'none', DeliveryType: 'Remote' } },
      { Name: 'Vacation', TimeZone: 'PST', StartDate: '2026-07-02', EndDate: '2026-07-05', Status: 'proposed', AdditionalProperties: { IsSystemGenerated: 'false', Comments: 'OOF' } },
    ],
  },
];

export const fmSampleManagers: ManagerSuggestion[] = [
  { alias: 'boss1', name: 'Boss One' },
  { alias: 'boss2', name: 'Boss Two' },
  { alias: 'cmanager', name: 'Carol Manager' },
];

export const fmSamplePending: PendingCalendarItem[] = [
  { Id: 1, ResourceId: 'jdoe', FirstName: 'Jane', LastName: 'Doe', EventTypeName: 'OOF', Comments: 'Family vacation', StartDate: '2026-07-10', EndDate: '2026-07-14', TimeZone: 'PST', EventColorName: '#0b6a0b' },
  { Id: 2, ResourceId: 'asmith', FirstName: 'Al', LastName: 'Smith', EventTypeName: 'Training', Comments: 'Azure certification', StartDate: '2026-07-20', EndDate: '2026-07-21', TimeZone: 'EST', EventColorName: '#8764b8' },
];

export const fmSampleDelegated: PendingCalendarItem[] = [
  { Id: 10, ResourceId: 'bwayne', ManagerAlias: 'boss2', FirstName: 'Bruce', LastName: 'Wayne', EventTypeName: 'OOF', Comments: 'Sabbatical', StartDate: '2026-07-15', EndDate: '2026-07-18', TimeZone: 'PST', EventColorName: '#0078d4' },
];

export const fmSampleAddMasterData: AddEventMasterData = {
  TimeZones: ['Pacific Standard Time', 'India Standard Time', 'Eastern Standard Time'],
  EventTypes: fmSampleEventTypes,
  ShowAs: ['Free', 'Busy', 'Tentative'],
  RecurrenceData: ['None', 'Daily', 'Weekly', 'Monthly'],
  PrimaryTechnologies: [
    { Id: 10, Name: 'Azure' },
    { Id: 11, Name: 'M365' },
    { Id: 12, Name: 'Dynamics 365' },
  ],
};
